export const reorderVideosByRequestedPattern = <T>(items: T[]): T[] => {
  if (items.length <= 2) {
    return items;
  }

  const order: number[] = [];
  const pushIndex = (index: number) => {
    if (index >= 0 && index < items.length && !order.includes(index)) {
      order.push(index);
    }
  };

  // Requested pattern:
  // 1, last, last-1, last-2, 2, last-3, last-4, 4, 5, 6...
  pushIndex(0);
  pushIndex(items.length - 1);
  pushIndex(items.length - 2);
  pushIndex(items.length - 3);
  pushIndex(1);
  pushIndex(items.length - 4);
  pushIndex(items.length - 5);

  for (let index = 3; index < items.length; index += 1) {
    pushIndex(index);
  }

  // Keep any not-explicitly-mentioned item(s) without dropping anything.
  for (let index = 0; index < items.length; index += 1) {
    pushIndex(index);
  }

  return order.map((index) => items[index]);
};
